import BaseWidgetProvider from '../base/BaseWidgetProvider'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'
import MonitoringWidget from './MonitoringWidget'

class MonitoringWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'MonitoringWidget'
  getName = () => 'Monitoring'
  getIcon = () => MonitorHeartIcon

  createWidget = (props) => <MonitoringWidget {...props} timeData={props.data} />
  createPreviewWidget = (props) => <MonitoringWidget {...props} timeData={props.data} />

  // Default size (can be overridden by user resize, but this is the initial size)
  size = { defaultW: 12, defaultH: 4, minW: 6, minH: 3 }

  getWidgetInfo = (columns, cellHeight) => {
    // Ensure we call super to get base info and merge with our specifics
    const baseInfo = super.getWidgetInfo(columns, cellHeight)
    return {
      ...baseInfo,
      w: this.size.defaultW,
      h: this.size.defaultH,
      minW: this.size.minW,
      minH: this.size.minH,
      availableWithoutDevice: false
    }
  }

  getConfigurationInfo = () => {
    return [
      {
        key: 'time',
        type: 'timeRange',
        defaultValue: '24:00:00'
      },
      {
        key: 'startTime',
        type: 'timeRange',
        defaultValue: new Date('2026-03-21T17:30:00.000Z')
      },
      {
        key: 'endTime',
        type: 'timeRange',
        defaultValue: new Date('2026-03-22T17:30:00.000Z')
      }
    ]
  }
}

export default MonitoringWidgetProvider
